module.exports = __webpack_public_path__ + "static/media/louvain_community.75cbb8e2.png";